import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Form, Card } from 'react-bootstrap';
import { Auth_Proto, Auth_Domain, Auth_Port } from '../../Component/consts';
import Header from '../../Component/Header';
import Menu from '../../Component/Menu';
import Footer from '../../Component/Footer';
import { Link } from 'react-router-dom';
import { currentTenant } from '../../Common/Credentials';

const DistributionSettings = () => {
    const [policy, setPolicy] = useState({
        statutoryReservePercentage: 10,
        statutoryReserveCapAmount: 50000
    });
    const tenantId = currentTenant; // || 'DEFAULT_TENANT'

    useEffect(() => {
        fetchPolicy();
    }, []);

    const fetchPolicy = async () => {
        try {
            const res = await axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/accounts/policy/${tenantId}`);
            if (res.data) {
                setPolicy(res.data);
            }
        } catch (err) {
            console.log("No policy found or error fetching.", err);
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/accounts/policy`, {
                ...policy,
                tenantId
            });
            alert("Policy saved successfully.");
        } catch (err) {
            console.error("Error saving policy:", err);
            alert("Failed to save policy.");
        }
    };

    return (
        <div>
            <Header />
            <Menu />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Distribution Settings</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item">
                                        <Link to="/accounts" className="btn btn-danger btn-sm text-white">
                                            <i className="fas fa-times"></i> Close
                                        </Link>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <Card className="p-3">
                            <Form onSubmit={handleSave}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Statutory Reserve Percentage (%)</Form.Label>
                                    <Form.Control 
                                        type="number" 
                                        step="0.01" 
                                        required 
                                        value={policy.statutoryReservePercentage} 
                                        onChange={e => setPolicy({...policy, statutoryReservePercentage: e.target.value})} 
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Statutory Reserve Cap (Monetary Amount)</Form.Label>
                                    <Form.Control 
                                        type="number" 
                                        step="0.01" 
                                        required 
                                        value={policy.statutoryReserveCapAmount} 
                                        onChange={e => setPolicy({...policy, statutoryReserveCapAmount: e.target.value})} 
                                    />
                                    <Form.Text className="text-muted">
                                        The absolute maximum value the statutory reserve can reach. Once reached, deductions stop.
                                    </Form.Text>
                                </Form.Group>
                                <Button className="btn hovbuttonColour text-white" type="submit">Save Policy Settings</Button>
                            </Form>
                        </Card>
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
};

export default DistributionSettings;
